import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted typefaces (SCOPE §2.1) — no CDN dependency at the register.
import '@fontsource-variable/inter';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import '@sitzmark/design/tokens.css';
import './styles/base.css';
import { App } from './app.js';
import { installSelectOnFocus } from './lib/select-on-focus.js';

// Pressing into a number box selects its number, so 2 typed is 2 (FB-1116).
installSelectOnFocus();

const container = document.getElementById('root');
if (container === null) throw new Error('No #root element to mount into');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
